/*Drop shadow filter
 * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/feGaussianBlur
 * */
exports.dropShadow = function (id, dx, dy, stdDeviation) {
  return (
    <filter id={id} key={id}>
      <feGaussianBlur in="SourceAlpha" stdDeviation={stdDeviation}/>
      <feOffset dx={dx} dy={dy}/>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  );
};
